import {
  Unit_instanceat14thlj150z as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  VOID7hggqo3abtya as VOID,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  println2shhhgwwt4c61 as println,
  StringBuildermazzzhj6kkai as StringBuilder,
  joinTo3533moo9lcgda as joinTo,
  protoOf180f3jzyo7rfj as protoOf,
  replaceqbix900hl8kl as replace,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  HashMap1a0ld5kgwhmhv as HashMap,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from './kotlin-kotlin-stdlib.mjs';
import { Companion_getInstancegk7jn4e7je7g as Companion_getInstance } from './korlibs-platform-root-korlibs-platform.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Color extends Enum {
  constructor(name, ordinal, index) {
    super(name, ordinal);
    this.v2v_1 = index;
  }
}
class AnsiEscape {}
function appendAnsiScape(_this__u8e3s4, code, extra, char) {
  _this__u8e3s4.vb(_Char___init__impl__6a9atx(27));
  _this__u8e3s4.vb(_Char___init__impl__6a9atx(91));
  _this__u8e3s4.xg(code);
  if (!(extra == null)) {
    _this__u8e3s4.ub(extra);
  }
  _this__u8e3s4.vb(char);
  return _this__u8e3s4;
}
function appendAnsiScape$default(_this__u8e3s4, code, extra, char, $super) {
  extra = extra === VOID ? null : extra;
  char = char === VOID ? _Char___init__impl__6a9atx(109) : char;
  return $super === VOID ? this.w2v(_this__u8e3s4, code, extra, char) : appendAnsiScape(_this__u8e3s4, code, extra, char);
}
function appendReset(_this__u8e3s4) {
  return this.x2v(_this__u8e3s4, 0);
}
function appendFgColor(_this__u8e3s4, color, bright) {
  return this.x2v(_this__u8e3s4, 30 + color.v2v_1 | 0, bright ? ';1' : null);
}
function appendFgColor$default(_this__u8e3s4, color, bright, $super) {
  bright = bright === VOID ? false : bright;
  return $super === VOID ? this.z2v(_this__u8e3s4, color, bright) : appendFgColor(_this__u8e3s4, color, bright);
}
class Kind extends Enum {
  constructor(name, ordinal, level, color) {
    super(name, ordinal);
    this.d2w_1 = level;
    this.e2w_1 = color;
  }
}
class BaseConsole {
  g2w(kind, msg) {
    var hook = baseConsoleHook;
    if (!(hook == null)) {
      hook(kind, msg, BaseConsole$logInternal$ref(this));
    } else {
      this.f2w(kind, msg.slice());
    }
  }
  f2w(kind, msg) {
    println(this.h2w(kind, msg.slice()));
  }
  h2w(kind, msg) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.logger.BaseConsole.logToString.<anonymous>' call
    var color = kind.e2w_1;
    if (!(color == null)) {
      this.a2w(this_0, color);
    }
    joinTo(msg, this_0, ', ');
    if (!(color == null)) {
      this.y2v(this_0);
    }
    return this_0.toString();
  }
  i2w(msg) {
    return this.g2w(Kind_LOG_getInstance(), msg.slice());
  }
  j2w(msg) {
    return this.g2w(Kind_WARN_getInstance(), msg.slice());
  }
  k2w(msg) {
    return this.g2w(Kind_ERROR_getInstance(), msg.slice());
  }
}
class Companion {
  constructor() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.ic(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.logger.Companion.BY_NAME.<anonymous>' call
      var tmp$ret$0 = element.j3_1;
      destination.b3(tmp$ret$0, element);
    }
    tmp.l2w_1 = destination;
  }
  ei(name) {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = name.toUpperCase();
    var tmp0_elvis_lhs = this.l2w_1.z2(tmp$ret$1);
    return tmp0_elvis_lhs == null ? Level_NONE_getInstance() : tmp0_elvis_lhs;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    this.m2w_1 = new Object();
    this.n2w_1 = HashMap.m8();
    this.o2w_1 = null;
    this.p2w_1 = DefaultLogOutput_instance;
  }
  tx(name) {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.m2w_1;
    var normalizedName = normalizeName(Companion_getInstance_1(), name);
    if (Companion_getInstance_1().n2w_1.z2(normalizedName) == null) {
      var logger = new Logger(name, normalizedName, true);
      var tmp0_safe_receiver = get_miniEnvironmentVariablesUC().z2('LOG_' + normalizedName);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.logger.Companion.invoke.<anonymous>.<anonymous>' call
        logger.w2w(Companion_getInstance_0().ei(tmp0_safe_receiver));
      }
      if (Companion_getInstance_1().n2w_1.g1()) {
        var tmp1_safe_receiver = get_miniEnvironmentVariablesUC().z2('LOG_LEVEL');
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.logger.Companion.invoke.<anonymous>.<anonymous>' call
          Companion_getInstance_1().o2w_1 = Companion_getInstance_0().ei(tmp1_safe_receiver);
        }
      }
      // Inline function 'kotlin.collections.set' call
      Companion_getInstance_1().n2w_1.b3(normalizedName, logger);
    }
    return ensureNotNull(Companion_getInstance_1().n2w_1.z2(normalizedName));
  }
}
class Level extends Enum {
  constructor(name, ordinal, index) {
    super(name, ordinal);
    this.z2w_1 = index;
  }
}
class ConsoleLogOutput {
  a2x(logger, level, msg) {
    switch (level.k3_1) {
      case 2:
        Console_getInstance().k2w([logger.q2w_1, msg]);
        break;
      case 3:
        Console_getInstance().j2w([logger.q2w_1, msg]);
        break;
      default:
        Console_getInstance().i2w([logger.q2w_1, msg]);
        break;
    }
  }
}
class Logger {
  constructor(name, normalizedName, dummy) {
    Companion_getInstance_1();
    this.q2w_1 = name;
    this.r2w_1 = normalizedName;
    this.s2w_1 = dummy;
    this.t2w_1 = null;
    this.u2w_1 = null;
    this.v2w_1 = null;
  }
  w2w(value) {
    this.u2w_1 = value;
  }
  b2x() {
    var tmp0_elvis_lhs = this.u2w_1;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? Companion_getInstance_1().o2w_1 : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? Level_WARN_getInstance() : tmp1_elvis_lhs;
  }
  c2x() {
    var tmp0_elvis_lhs = this.v2w_1;
    return tmp0_elvis_lhs == null ? Companion_getInstance_1().p2w_1 : tmp0_elvis_lhs;
  }
  d2x(level) {
    return level.z2w_1 <= this.b2x().z2w_1;
  }
  e2x(level, msg) {
    this.c2x().a2x(this, level, msg);
  }
}
class Console extends BaseConsole {
  constructor() {
    Console_instance = null;
    super();
    Console_instance = this;
  }
  f2w(kind, msg) {
    switch (kind.k3_1) {
      case 0:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.error.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      case 1:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.warn.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      case 2:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.info.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      case 3:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      case 4:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      case 5:
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].slice.call(msg.slice()));
        }.call(this));
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
}
class DefaultLogOutput {
  a2x(logger, level, msg) {
    return ConsoleLogOutput_instance.a2x(logger, level, msg);
  }
}
//endregion
var Color_BLACK_instance;
var Color_RED_instance;
var Color_GREEN_instance;
var Color_YELLOW_instance;
var Color_BLUE_instance;
var Color_PURPLE_instance;
var Color_CYAN_instance;
var Color_WHITE_instance;
var Color_entriesInitialized;
function Color_initEntries() {
  if (Color_entriesInitialized)
    return Unit_instance;
  Color_entriesInitialized = true;
  Color_BLACK_instance = new Color('BLACK', 0, 0);
  Color_RED_instance = new Color('RED', 1, 1);
  Color_GREEN_instance = new Color('GREEN', 2, 2);
  Color_YELLOW_instance = new Color('YELLOW', 3, 3);
  Color_BLUE_instance = new Color('BLUE', 4, 4);
  Color_PURPLE_instance = new Color('PURPLE', 5, 5);
  Color_CYAN_instance = new Color('CYAN', 6, 6);
  Color_WHITE_instance = new Color('WHITE', 7, 7);
}
function Color_RED_getInstance() {
  Color_initEntries();
  return Color_RED_instance;
}
function Color_GREEN_getInstance() {
  Color_initEntries();
  return Color_GREEN_instance;
}
function Color_YELLOW_getInstance() {
  Color_initEntries();
  return Color_YELLOW_instance;
}
function Color_BLUE_getInstance() {
  Color_initEntries();
  return Color_BLUE_instance;
}
function Color_CYAN_getInstance() {
  Color_initEntries();
  return Color_CYAN_instance;
}
var baseConsoleHook;
var Kind_ERROR_instance;
var Kind_WARN_instance;
var Kind_INFO_instance;
var Kind_DEBUG_instance;
var Kind_TRACE_instance;
var Kind_LOG_instance;
var Kind_entriesInitialized;
function Kind_initEntries() {
  if (Kind_entriesInitialized)
    return Unit_instance;
  Kind_entriesInitialized = true;
  Kind_ERROR_instance = new Kind('ERROR', 0, 0, Color_RED_getInstance());
  Kind_WARN_instance = new Kind('WARN', 1, 1, Color_YELLOW_getInstance());
  Kind_INFO_instance = new Kind('INFO', 2, 2, Color_BLUE_getInstance());
  Kind_DEBUG_instance = new Kind('DEBUG', 3, 3, Color_CYAN_getInstance());
  Kind_TRACE_instance = new Kind('TRACE', 4, 4, Color_GREEN_getInstance());
  Kind_LOG_instance = new Kind('LOG', 5, 5, null);
}
function BaseConsole$logInternal$ref($boundThis) {
  var l = function (p0, p1) {
    $boundThis.f2w(p0, p1);
    return Unit_instance;
  };
  l.callableName = 'logInternal';
  return l;
}
function Kind_ERROR_getInstance() {
  Kind_initEntries();
  return Kind_ERROR_instance;
}
function Kind_WARN_getInstance() {
  Kind_initEntries();
  return Kind_WARN_instance;
}
function Kind_LOG_getInstance() {
  Kind_initEntries();
  return Kind_LOG_instance;
}
var _miniEnvironmentVariablesUC;
function normalizeName($this, name) {
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  return replace(replace(name, _Char___init__impl__6a9atx(46), _Char___init__impl__6a9atx(95)), _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(95)).toUpperCase();
}
var Level_NONE_instance;
var Level_FATAL_instance;
var Level_ERROR_instance;
var Level_WARN_instance;
var Level_INFO_instance;
var Level_DEBUG_instance;
var Level_TRACE_instance;
var Companion_instance;
function Companion_getInstance_0() {
  Level_initEntries();
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function values() {
  return [Level_NONE_getInstance(), Level_FATAL_getInstance(), Level_ERROR_getInstance(), Level_WARN_getInstance(), Level_INFO_getInstance(), Level_DEBUG_getInstance(), Level_TRACE_getInstance()];
}
function valueOf(value) {
  switch (value) {
    case 'NONE':
      return Level_NONE_getInstance();
    case 'FATAL':
      return Level_FATAL_getInstance();
    case 'ERROR':
      return Level_ERROR_getInstance();
    case 'WARN':
      return Level_WARN_getInstance();
    case 'INFO':
      return Level_INFO_getInstance();
    case 'DEBUG':
      return Level_DEBUG_getInstance();
    case 'TRACE':
      return Level_TRACE_getInstance();
    default:
      Level_initEntries();
      THROW_IAE('No enum constant value.');
      break;
  }
}
var Level_entriesInitialized;
function Level_initEntries() {
  if (Level_entriesInitialized)
    return Unit_instance;
  Level_entriesInitialized = true;
  Level_NONE_instance = new Level('NONE', 0, 0);
  Level_FATAL_instance = new Level('FATAL', 1, 1);
  Level_ERROR_instance = new Level('ERROR', 2, 2);
  Level_WARN_instance = new Level('WARN', 3, 3);
  Level_INFO_instance = new Level('INFO', 4, 4);
  Level_DEBUG_instance = new Level('DEBUG', 5, 5);
  Level_TRACE_instance = new Level('TRACE', 6, 6);
  Companion_getInstance_0();
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
var ConsoleLogOutput_instance;
function ConsoleLogOutput_getInstance() {
  return ConsoleLogOutput_instance;
}
function Level_NONE_getInstance() {
  Level_initEntries();
  return Level_NONE_instance;
}
function Level_FATAL_getInstance() {
  Level_initEntries();
  return Level_FATAL_instance;
}
function Level_ERROR_getInstance() {
  Level_initEntries();
  return Level_ERROR_instance;
}
function Level_WARN_getInstance() {
  Level_initEntries();
  return Level_WARN_instance;
}
function Level_INFO_getInstance() {
  Level_initEntries();
  return Level_INFO_instance;
}
function Level_DEBUG_getInstance() {
  Level_initEntries();
  return Level_DEBUG_instance;
}
function Level_TRACE_getInstance() {
  Level_initEntries();
  return Level_TRACE_instance;
}
function get_miniEnvironmentVariablesUC() {
  if (_miniEnvironmentVariablesUC == null) {
    // Inline function 'kotlin.collections.mapKeys' call
    var this_0 = get_miniEnvironmentVariables();
    // Inline function 'kotlin.collections.mapKeysTo' call
    var destination = LinkedHashMap.ic(mapCapacity(this_0.e1()));
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_iterator = this_0.l1().a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.logger.<get-miniEnvironmentVariablesUC>.<anonymous>' call
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = element.m1().toUpperCase();
      // Inline function 'kotlin.collections.mapKeysTo.<anonymous>' call
      var tmp$ret$3 = element.n1();
      destination.b3(tmp, tmp$ret$3);
    }
    _miniEnvironmentVariablesUC = destination;
  }
  return ensureNotNull(_miniEnvironmentVariablesUC);
}
function get_miniEnvironmentVariables() {
  return Companion_getInstance().gv();
}
var Console_instance;
function Console_getInstance() {
  if (Console_instance === VOID)
    new Console();
  return Console_instance;
}
var DefaultLogOutput_instance;
function DefaultLogOutput_getInstance() {
  return DefaultLogOutput_instance;
}
//region block: post-declaration
initMetadataForClass(Color, 'Color');
initMetadataForInterface(AnsiEscape, 'AnsiEscape');
initMetadataForClass(Kind, 'Kind');
protoOf(BaseConsole).w2v = appendAnsiScape;
protoOf(BaseConsole).x2v = appendAnsiScape$default;
protoOf(BaseConsole).y2v = appendReset;
protoOf(BaseConsole).z2v = appendFgColor;
protoOf(BaseConsole).a2w = appendFgColor$default;
initMetadataForClass(BaseConsole, 'BaseConsole', BaseConsole, VOID, [AnsiEscape]);
initMetadataForCompanion(Companion);
initMetadataForCompanion(Companion_0);
initMetadataForClass(Level, 'Level');
initMetadataForObject(ConsoleLogOutput, 'ConsoleLogOutput');
initMetadataForClass(Logger, 'Logger');
initMetadataForObject(Console, 'Console');
initMetadataForObject(DefaultLogOutput, 'DefaultLogOutput');
//endregion
//region block: init
baseConsoleHook = null;
_miniEnvironmentVariablesUC = null;
ConsoleLogOutput_instance = new ConsoleLogOutput();
DefaultLogOutput_instance = new DefaultLogOutput();
//endregion
//region block: exports
export {
  Level_DEBUG_getInstance as Level_DEBUG_getInstancewzibhbcrmy7h,
  Level_ERROR_getInstance as Level_ERROR_getInstance18552yzhsfztk,
  Level_INFO_getInstance as Level_INFO_getInstance3huxkjtm54h8u,
  Level_TRACE_getInstance as Level_TRACE_getInstance1ni95vo21pald,
  Level_WARN_getInstance as Level_WARN_getInstance2cg04z8rod8ga,
  Console_getInstance as Console_getInstance8lqb2pbph5yn,
  Companion_getInstance_1 as Companion_getInstance3qvmjlq9y5ia6,
  valueOf as valueOf3aj0dpb8xpu5n,
};
//endregion
